import { format, intervalToDuration } from "date-fns";
import CustomTableRow from "../table/CustomTableRow";
import { calculateDuration, secondsToString } from "../../utils/common";
import React, { useRef, useState } from "react";
import { createPopper } from "@popperjs/core";
import SidePanel from "../sidePanel/SidePanel";
import JourneySidePanel from "./JourneySidePanel";
import { ChevronRight } from "@mui/icons-material";
import { JOURNEY_STATUS, getStatusChipType, getStatusLabel } from "../../constants/journeyStatus";


export const StatusChip = ({ type, text }) => {
  return (
    <p
      className={`inline-flex px-2 py-1 text-xs font-semibold items-center leading-5 rounded ${type === "warning"
        ? "text-orange-500 bg-orange-400"
        : type === "error"
          ? "text-red-500 bg-red-400"
          : type === "end"
            ? "text-pink-500 bg-pink-400"
            : "text-green-500 bg-green-500"
        } bg-opacity-30`}
    >
      <span className="flex items-center whitespace-normal">{text}</span>
    </p>
  );
};

export default function JourneyTableRow({ row, refetch }) {

  const [isMouseEnter, setIsMouseEnter] = useState(false);
  const [open, setOpen] = useState(
    false
  );

  const openSideBar = () => {
    setOpen(true);
  };

  const ShowStatus = () => {

    const status = row.journeyStatus;
    const chipType = getStatusChipType(status);
    if (!chipType) return null;
    const chip = <StatusChip type={chipType} text={getStatusLabel(status)} />;
    return chipType === "error" ? <div>{chip}</div> : chip;
  };


  const JourneyDuration = () => {
    const [tooltipShow, setTooltipShow] = React.useState(false);
    const btnRef = useRef();
    const tooltipRef = useRef();

    const openTooltip = () => {
      createPopper(btnRef.current, tooltipRef.current, {
        placement: "right",
      });
      setTooltipShow(true);
    };
    const closeTooltip = () => {
      setTooltipShow(false);
    };

    return row.startTime && row.endTime ? (
      calculateDuration(row.startTime, row.endTime, true)
    ) : row.journeyStatus === JOURNEY_STATUS.FAILED ? "-" : (
      <StatusChip type="end" text="Ongoing" />
    )
  };

  const handleOnMouseEnter = () => {
    setIsMouseEnter(true);
  };

  const handleOnMouseLeave = () => {
    setIsMouseEnter(false);
  };


  const showSidebar = () => {
    return (
      <div
        className="md:ml-20 xl:ml-16 flex items-center justify-center relative hover:cursor-pointer"
        onClick={() => openSideBar()}
      >
        {isMouseEnter ? (
          <p className=" absolute whitespace-nowrap right-5 text-purple-350 text-sm mb-0">
            View Journey
          </p>
        ) : (
          <div className="absolute" style={{ width: "24px" }} />
        )}
        <ChevronRight
          className={`w-5 h-5 ${isMouseEnter ? "text-purple-350" : "text-[#212121]"
            }`}
        />
      </div>
    );
  };

  return (
    <>
      <CustomTableRow
        onMouseEnterAction={handleOnMouseEnter}
        onMouseLeaveAction={handleOnMouseLeave}
        columns={[
          {

            text: row.journeyId,
            onTextClick: () => {
              openSideBar();
            },
          },

          {
            text: `${row.applicationNo}`,
          },

          {
            text: `${row.agentCode}`,
          },
          {
            text: format(new Date(row.startTime), "dd MMM yyyy, hh:mm a"),
          },
          {

            actions: [JourneyDuration]

          },
          {
            actions: [ShowStatus],
          },
          {
            text: `${row.disagreeReason ? row.disagreeReason : "-"}`,
          },
          {
            actions: [showSidebar],
          }
        ]}
      ></CustomTableRow>
      <SidePanel
        open={open}
        setOpen={(e) => {
          if (e === false) {
            // refetch();
          }
          setOpen(e);
        }}
        encodingDetailWidth={true}
      >
        <JourneySidePanel row={row} setOpen={setOpen} />
      </SidePanel>
    </>
  );
}
